"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var Title_1 = require("../../defaults/Title");
var Description_1 = require("../../defaults/Description");
var _helpers_1 = require("../../helpers");
var _styled_1 = require("../../styled-components");
var react_1 = __importDefault(require("react"));
var query = new URLSearchParams(window.location.search).get('q');
var getTextElementFromArray = function (text) {
    if (navigator.userAgent === 'ReactSnap') {
        return '';
    }
    var res = text === null || text === void 0 ? void 0 : text.find(function (t) { return t.key === query; });
    if (res) {
        return res.value;
    }
    var defaultText = text === null || text === void 0 ? void 0 : text.find(function (t) { return t.key === 'default'; });
    return (defaultText === null || defaultText === void 0 ? void 0 : defaultText.value) || '';
};
var Text = function (_a) {
    var text = _a.text, size = _a.size, _b = _a.margin, margin = _b === void 0 ? Description_1.defaultDescriptionConfig.margin : _b, _c = _a.padding, padding = _c === void 0 ? Description_1.defaultDescriptionConfig.padding : _c, fontSize = _a.fontSize, dark = _a.dark, spanConfig = _a.spanConfig, defaultCss = _a.defaultCss, nativeProps = _a.nativeProps;
    var isTitle = size && size > 0;
    var mergedFontSize = isTitle
        ? fontSize
        : fontSize || Description_1.defaultDescriptionConfig.fontSize;
    var cssToApply = __assign({ textTransform: Title_1.defaultTitleConfig.textTransform, fontWeight: isTitle ? 'bold' : Title_1.defaultTitleConfig.fontWeight, fontStyle: Description_1.defaultDescriptionConfig.fontStyle, letterSpacing: Description_1.defaultDescriptionConfig.letterSpacing, textAlign: isTitle ? Title_1.defaultTitleConfig.textAlign : 'left' }, defaultCss);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(_styled_1.TextElementStyled, __assign({ as: size ? "h" + size : 'p', spanConfig: spanConfig, margin: margin, padding: padding, fontSize: mergedFontSize, dark: dark, defaultCss: cssToApply }, nativeProps), _helpers_1.parse(typeof text === 'string' ? text : getTextElementFromArray(text)))));
};
exports.default = Text;
//# sourceMappingURL=Text.js.map